<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BceWGM/tc-custom/9783987440953.jpg?1704395575542" alt="This image is the cover for the book The Story of Treasure Seekers, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Story of Treasure Seekers, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The Story of the Treasure Seekers is a children's adventure novel by Edith Nesbit. First published in 1899, the book follows a group of siblings who set about restoring the family fortune after their father loses his business. It's the first book in the Bastable Children series, and it's Nesbit's most popular novel.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. Nesbit
      </h2>
      
      <p class="authorDescription body article">Edith Nesbit (married name Edith Bland; 15 August 1858 – 4 May 1924) was an English writer and poet, who published her books for children as E. Nesbit. She wrote or collaborated on more than 60 such books. She was also a political activist and co-founder of the Fabian Society, a socialist organisation later affiliated to the Labour Party.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23e9ec62